@if (!hideFab()) {
  <button
    [ngStyle]="fabStyle()"
    [flxDragPadding]="dragPadding"
    [flxDrag]="DragType.MAGNETIC"
    [pTooltip]="'AI Command Center'"
    [tooltipPosition]="'top'"
    (click)="showWindow()"
    (flxDragEnd)="onDragEnd($event)"
    (flxDragMove)="onDragMove($event)"
    class="fixed w-10 h-10 flex flex-row justify-center items-center content-center bg-[var(--flx-ai-fab-bg)] rounded-full shadow-lg"
    data-testId="ai-fab-button"
  >
    <flx-icon
      name="stars-flowx-black"
      class="w-5 h-5"
    />
  </button>
}
